import angular from "angular";

let NotificationDetailController = function (
  $filter,
  $mdDialog,
  $scope,
  $state,
  $timeout,
  City,
  News,
  Notification,
  State,
  Toast
) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.notification = {
    only_vaccine_regions: null,
  };
  $ctrl.disabledFilterStateCities = false;
  $ctrl.regionTypes = [
    { text: "Todas", value: null },
    { text: "Com vacinas", value: true },
    { text: "Não possuem vacinas", value: false },
  ];
  $ctrl.filter = {};
  $ctrl.search = "";
  $ctrl.searchState = "";
  $ctrl.selectedCities = [];
  $ctrl.selectedStates = [];
  $ctrl.disabledInputs = false;
  $ctrl.minDate = new Date();
  $ctrl.maxDate = new Date(
    `${$ctrl.minDate.getFullYear() + 5}-${
      $ctrl.minDate.getUTCMonth() + 1
    }-${$ctrl.minDate.getUTCDate()}`
  );
  $ctrl.original = {
    states: [],
    cities: [],
  };

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    onChangeDate,
    onChangeState,
    querySearch,
    selectedNewsItemChange,
    setListContent,
    filterContent,
    onChangeRegionType,
  });

  $timeout(function () {
    angular
      .element(document.querySelector(".input-search-state"))
      .on("keydown", function (ev) {
        ev.stopPropagation();
      });
  }, 500);

  activate();

  function activate() {
    clearForm();

    loadDomainResources()
      .then((result) => {
        $ctrl.newsItems = result[0];
        $ctrl.states = result[1];
        $ctrl.original.states = result[1];

        loadResource($ctrl.id);
      })
      .catch((err) => {
        console.log("err:", err);
        $ctrl.uiState = "ERROR";
      });
  }

  function clearForm(form) {
    $ctrl.notification = {
      receiver: "ALL",
      only_vaccine_regions: null,
      send_at: moment().add(1, "days"),
    };
    $ctrl.filter = {};
    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(notification, event) {
    let confirmMessage = "notification-detail-delete-confirm-text";

    let confirm = $mdDialog
      .confirm()
      .textContent($filter("translate")(confirmMessage))
      .ariaLabel($filter("translate")(confirmMessage))
      .targetEvent(event)
      .ok($filter("translate")("common-yes"))
      .cancel($filter("translate")("common-cancel"));

    $mdDialog
      .show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Notification.destroy(notification)
          .then((response) => {
            Toast.success(
              $filter("translate")("notification-detail-delete-success")
            );
            $ctrl.deleting = false;
            $state.go("notification.list");
          })
          .catch((err) => {
            Toast.error($filter("translate")("common-server-error"));
            console.log("err:", err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {});
  }

  function handleSave(form, notification) {
    if (!form.$valid) {
      Toast.error($filter("translate")("common-form-incomplete"));
      return;
    }

    if ($ctrl.hasNewsItem) {
      notification.type = "NEWS_ITEM";
    } else if ($ctrl.notification.url) {
      notification.type = "REDIRECT_NOTIFICATION";
      delete notification.type_id;
    } else {
      notification.type = "GENERAL";
      delete notification.type_id;
    }

    if ($ctrl.filter.state_id || $ctrl.filter.gender) {
      notification.filter = {
        gender: $ctrl.filter.gender,
        state_id:
          $ctrl.filter.state_id[0] === null ? null : $ctrl.filter.state_id,
        city_id:
          $ctrl.filter.city_id && $ctrl.filter.city_id[0] === null
            ? null
            : $ctrl.filter.city_id,
      };
    }

    const deleteFilter = Object.values(notification.filter).every((value) => {
      if (value === null) return true;
      return false;
    });
    if (deleteFilter) delete notification.filter;

    if ($ctrl.isScheduled) {
      let sendAt = moment($ctrl.notification.send_at);
      let datetimeText = sendAt.format("YYYY-MM-DD") + " " + $ctrl.sendAtTime;
      notification.send_at = moment(datetimeText);
      save(notification);
    } else {
      let confirmMessage = "notification-detail-send-now-confirm-text";

      let confirm = $mdDialog
        .confirm()
        .textContent($filter("translate")(confirmMessage))
        .ariaLabel($filter("translate")(confirmMessage))
        .targetEvent(event)
        .ok($filter("translate")("common-ok"))
        .cancel($filter("translate")("common-cancel"));

      $mdDialog
        .show(confirm)
        .then(() => {
          notification.send_at = null;
          save(notification);
        })
        .catch(() => {});
    }
  }

  function onChangeDate(form) {
    $timeout(() => {
      form.sendAtTime.$validate();
    }, 100);
  }

  function onChangeState(stateIdArr) {
    if (stateIdArr.length !== 0) {
      $ctrl.filter.city_id = null;
      $ctrl.loadingCities = true;
      City.index({
        state_id: stateIdArr,
        limit: 1000000,
      })
        .then((cities) => {
          $ctrl.cities = cities;
          $ctrl.original.cities = cities;
          $ctrl.selectedCities = [];
          $ctrl.loadingCities = false;
        })
        .catch((err) => {
          console.log("err:", err);
          $ctrl.loadingCities = false;
        })
        .finally(() => {
          angular
            .element(document.querySelector(".input-search-city"))
            .on("keydown", function (ev) {
              ev.stopPropagation();
            });
        });
    }

    if (stateIdArr && stateIdArr.length > 1) {
      $ctrl.search = "";
      $ctrl.filter.city_id = null;
      $ctrl.cities = [];
    }
  }

  function onChangeRegionType() {
    $ctrl.filter.state_id = [];
    $ctrl.selectedStates = [];
    $ctrl.selectedCities = [];
    $ctrl.filter.city_id = [];
    $ctrl.disabledFilterStateCities =
      $ctrl.notification.only_vaccine_regions !== null;
  }

  function querySearch(searchText) {
    searchText = searchText.toLowerCase();
    let newsTypeToExclude =
      $ctrl.notification.type === "MEDIC" ? "SBRUBBLES" : "MEDIC";

    let results = _.filter($ctrl.newsItems, (newsItem) => {
      return (
        newsItem.title.toLowerCase().indexOf(searchText) > -1 &&
        newsItem.user_profile_type != newsTypeToExclude
      );
    });

    return results;
  }

  function selectedNewsItemChange(newsItem) {
    $ctrl.notification.type_id = newsItem ? newsItem.id : null;
  }

  // Local functions
  function loadResource(id) {
    if (id) {
      $ctrl.uiState = "LOADING";

      Notification.show(id)
        .then((response) => {
          $ctrl.notification = response;
          $ctrl.notification.send_at = new Date($ctrl.notification.send_at);
          $ctrl.notification.only_vaccine_regions =
            response.only_vaccine_regions === undefined
              ? null
              : response.only_vaccine_regions;
          if (response.state_id) {
            onChangeState(response.state_id);
          }
          $ctrl.filter = {
            gender: response.gender,
            state_id: response.state_id === null ? [null] : response.state_id,
            city_id: response.city_id === null ? [null] : response.city_id,
          };
          if (response.send_at) {
            $ctrl.isScheduled = true;
            setTime(response.send_at);
          } else {
            $ctrl.isSent = true;
          }

          if (response.type === "NEWS_ITEM" && response.type_id) {
            $ctrl.hasNewsItem = true;
            $ctrl.selectedNewsItem = _.find($ctrl.newsItems, {
              id: response.type_id,
            });
          }

          $ctrl.uiState = "COMPLETE";
        })
        .catch((err) => {
          console.log("err:", err);
          $ctrl.uiState = "ERROR";
        });
    } else {
      $ctrl.uiState = "COMPLETE";
      $scope.$apply();
    }
  }

  function loadDomainResources() {
    $ctrl.uiState = "LOADING";

    let promises = [];

    promises.push(News.index({ limit: 10000000000, order: "updated_at DESC" }));
    promises.push(State.index({ limit: 10000000000 }));

    return Promise.all(promises);
  }

  function save(notification) {
    notification.is_public = true;

    $ctrl.saving = true;

    Notification.save(notification)
      .then((response) => {
        Toast.success($filter("translate")("notification-detail-save-success"));
        $ctrl.notification = response;
        $ctrl.saving = false;
        $state.go("notification.list");
      })
      .catch((err) => {
        let defaultErrMsg = "common-server-error";
        let fourONineMsg = "notification-detail-409-error";
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter("translate")(message));
        console.log("err:", err);
        $ctrl.saving = false;
      });
  }

  function setTime(sendAt) {
    let datetime = moment(sendAt);
    $ctrl.isSent = datetime.isSameOrBefore(moment());
    let timeText = datetime.format("HH:mm");
    $ctrl.sendAtTime = timeText;
  }

  function setListContent(name, list) {
    if (name) {
      const idx = list.findIndex((city) => {
        return name === city;
      });

      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.push(name);
      }
    } else {
      list.length = 0;
    }
  }

  function filterContent(query, type) {
    let filtered = [];

    if (query) {
      filtered = $ctrl.original[type].filter(({ name }) => {
        name = name.toLowerCase();
        return (
          name.includes(query) ||
          name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(query)
        );
      });
    }

    $ctrl[type] = query ? filtered : $ctrl.original[type];
  }
};

NotificationDetailController.$inject = [
  "$filter",
  "$mdDialog",
  "$scope",
  "$state",
  "$timeout",
  "City",
  "News",
  "Notification",
  "State",
  "Toast",
];

export default NotificationDetailController;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification-detail.controller.js